var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.3215L6.42259 7.74409C6.09715 7.41865 5.56951 7.41865 5.24408 7.74409C4.91864 8.06953 4.91864 8.59716 5.24408 8.9226L9.41074 13.0893C9.73618 13.4147 10.2638 13.4147 10.5893 13.0893L14.7559 8.9226C15.0814 8.59716 15.0814 8.06953 14.7559 7.74409C14.4305 7.41865 13.9028 7.41865 13.5774 7.74409L10 11.3215Z",
    fill: "#051033",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 10,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.3215L6.42259 7.74409C6.09715 7.41865 5.56951 7.41865 5.24408 7.74409C4.91864 8.06953 4.91864 8.59716 5.24408 8.9226L9.41074 13.0893C9.73618 13.4147 10.2638 13.4147 10.5893 13.0893L14.7559 8.9226C15.0814 8.59716 15.0814 8.06953 14.7559 7.74409C14.4305 7.41865 13.9028 7.41865 13.5774 7.74409L10 11.3215Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_327)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H20V-9.53674e-07H0V20Z",
    fill: "#1B2559"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseArrow);
export default __webpack_public_path__ + "static/media/closeArrow.68d8cd33794f502080b88fd63b065a50.svg";
export { ForwardRef as ReactComponent };